import React from 'react';
import { Campaign, CampaignItem } from '../../types';
import { CampaignItemsListPanel } from '../CampaignItemsListPanel/CampaignItemsListPanel';
import './CampaignItemsListModal.css';

export interface CampaignItemsListModalProps {
  open: boolean;
  campaign: Campaign | undefined;
  items: CampaignItem[];
  onClose: () => void;
}

export const CampaignItemsListModal: React.FC<CampaignItemsListModalProps> = ({
  open,
  campaign,
  items,
  onClose,
}) => {
  if (!open) return null;

  const title = campaign?.nome || 'Campanha';

  return (
    <div className="campaign-items-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="campaign-items-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="campaign-items-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="campaign-items-modal-header">
          <div>
            <h2 id="campaign-items-modal-title">{title}</h2>
            <p className="campaign-items-modal-sub">
              {items.length} contato(s) nesta campanha · lista fora do Kanban · use os filtros para localizar itens
            </p>
          </div>
          <button type="button" className="campaign-items-modal-close" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </header>

        <div className="campaign-items-modal-body">
          <CampaignItemsListPanel items={items} showRemarketingHint />
        </div>
      </div>
    </div>
  );
};
